import { useTacticHooks } from '../providers/TacticHooksProvider';
import { QueryOptions } from './types';
import { LeavePolicyType } from '@gettactic/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const USE_LEAVE_POLICIES_QUERY_KEY = 'leavePolicies';
export function useAllApplicablePolicies(
  params: { tz: string; start?: string; end?: string; type?: LeavePolicyType[] },
  options: QueryOptions = { keepPreviousData: true, enabled: true }
) {
  const queryClient = useQueryClient();
  const { apiClient } = useTacticHooks();
  const query = useQuery({
    queryKey: [USE_LEAVE_POLICIES_QUERY_KEY, params],

    queryFn: async () => {
      const res = await apiClient.leave.allApplicablePolicies(params);
      return res.filter((x) => !!x && !!x.policy);
    },

    ...options
  });

  const invalidate = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [USE_LEAVE_POLICIES_QUERY_KEY]
    });
  }, []);
  return { query, invalidate };
}

export function useApplicableRemotePolicy(
  params: { tz: string; start?: string; end?: string },
  options?: QueryOptions
) {
  const { query } = useAllApplicablePolicies({ ...params, type: ['remote'] }, options);
  return query.data?.find((x) => x?.policy?.policy_type === 'remote') ?? null;
}
